import { UserSubscriptionBillingCycleUsageData } from '../UserSubscriptionPlans/constants';
import type { UserSubscriptionBillingPeriod } from '../UserSubscriptionPlans/selectors';

export type UserSubscriptionBillingCycleUsages = Readonly<
  UserSubscriptionBillingCycleUsageData[]
>;

export type UserSubscriptionBillingCycleUsageSummary = Readonly<{
  institutionUsages: UserSubscriptionBillingCycleUsages;
  subscriptionUsages: UserSubscriptionBillingCycleUsages;
  subscriptionId: string;
}>;

export type MonthlyUsage = {
  yearAndMonth: string;
  numLearners: number;
};

export type InstitutionMonthlyUsage = Readonly<MonthlyUsage>;

export type InstitutionMonthlyUsages = Readonly<InstitutionMonthlyUsage[]>;

export type InstitutionMonthlyUsageSummary = Readonly<{
  monthlyUsages: InstitutionMonthlyUsages;
  subscriptionId: string;
}>;

export enum InstitutionMonthlyUsageDataResponseKind {
  loading = 'loading',
  success = 'success',
  forbidden = 'forbidden',
}

export type InstitutionMonthlyUsageDataLoading = {
  kind: InstitutionMonthlyUsageDataResponseKind.loading;
  value: InstitutionMonthlyUsageSummary;
};

export type InstitutionMonthlyUsageDataSuccess = {
  kind: InstitutionMonthlyUsageDataResponseKind.success;
  value: InstitutionMonthlyUsageSummary;
};

export type InstitutionMonthlyUsageDataForbidden = {
  kind: InstitutionMonthlyUsageDataResponseKind.forbidden;
};

export type InstitutionMonthlyUsageData =
  | InstitutionMonthlyUsageDataLoading
  | InstitutionMonthlyUsageDataSuccess
  | InstitutionMonthlyUsageDataForbidden;

export type BillingPeriods = Readonly<UserSubscriptionBillingPeriod[]>;

export type BillingPeriodSummary = Readonly<{
  billingPeriods: BillingPeriods;
}>;
